import XHeader from 'vux/src/components/x-header/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'















export default {
name: 'myHead',
directives: {
TransferDom
},
components: {
XHeader,
Popup
},

props: ['title', 'showMore', 'leftText', 'rightText', 'changeLeft'],

data () {
return {
showBack: true,
showMenus: false,
showMore1: true,
changeRight: false,
changeleft: false
}
},

created () {

},

mounted () {
if(this.showMore == 'false' || this.showMore == false){
this.showMore1 = false
}
if(this.leftText != undefined){
this.showBack = false
this.changeleft = true
}
if(this.rightText != undefined){
this.changeRight = true
this.showMore1 = false
}
},

methods: {
leftEvent () {
this.$emit('leftEvent', '');
},
rightEvent () {
this.$emit('rightEvent', '');
},
}
}


// WEBPACK FOOTER //
// ./src/components/header/script.js